(function () {
  const startWrapper = document.getElementById('diagnose-start');
  const diagnoseWrapper = document.getElementById('diagnose');

  const setStep = (currentQuestionId, nextQuestionId, currentCircleId, nextCircleId) => {
    const currentQuestion = document.getElementById(currentQuestionId);
    const nextQuestion = document.getElementById(nextQuestionId);
    const currentCircle = document.getElementById(currentCircleId);
    const nextCircle = document.getElementById(nextCircleId);
    if (currentQuestion && nextQuestion) {
      currentQuestion.classList.remove('current');
      nextQuestion.classList.add('current');
    }
    if (currentCircle && nextCircle) {
      currentCircle.classList.remove('current');
      nextCircle.classList.add('current');
    }
  };

  const showDiagnose = () => {
    if (startWrapper) startWrapper.classList.add('hide');
    if (diagnoseWrapper) diagnoseWrapper.classList.add('show');
    const errorEl = document.getElementById('diagnose-error');
    if (errorEl) {
      errorEl.remove();
    }
  };

  if (diagnoseWrapper && startWrapper) {
    const startBtn = document.getElementById('diagnose-start-btn');
    if (startBtn) {
      startBtn.addEventListener('click', showDiagnose);
    }

    // question-1
    const q1Select = document.getElementById('question-1-select');
    if (q1Select) {
      q1Select.addEventListener('change', () => {
        const q1Value = document.getElementById('question-1-value');
        if (q1Value) {
          q1Value.value = q1Select.value;
        }
        setStep('question-1', 'question-2', 'diagnose-circle-1', 'diagnose-circle-2');
      });
    }

    // question-2
    document.querySelectorAll('.question-2-btn').forEach((el) => {
      el.addEventListener('click', () => {
        const valueEl = el.querySelector('.question-2-value');
        const q2Value = document.getElementById('question-2-value');
        if (valueEl && q2Value) {
          q2Value.value = valueEl.textContent.replace(/ /g, '');
        }
        setStep('question-2', 'question-3', 'diagnose-circle-2', 'diagnose-circle-3');
      });
    });

    // question-3
    document.querySelectorAll('.question-3-btn').forEach((el) => {
      el.addEventListener('click', () => {
        const valueEl = el.querySelector('.question-3-value');
        const q3Value = document.getElementById('question-3-value');
        if (valueEl && q3Value) {
          q3Value.value = valueEl.textContent.replace(/ /g, '');
        }
        setStep('question-3', 'question-4', 'diagnose-circle-3', 'diagnose-circle-4');
      });
    });

    // question-4
    document.querySelectorAll('.question-4-btn').forEach((el) => {
      el.addEventListener('click', () => {
        const valueEl = el.querySelector('.question-4-value');
        const q4Value = document.getElementById('question-4-value');
        if (valueEl && q4Value) {
          q4Value.value = valueEl.textContent.replace(/ /g, '');
        }
        setStep('question-4', 'question-5', 'diagnose-circle-4', 'diagnose-circle-5');
      });
    });

    // question-5
    document.querySelectorAll('.question-5-btn').forEach((el) => {
      el.addEventListener('click', () => {
        const valueEl = el.querySelector('.question-5-value');
        const q5Value = document.getElementById('question-5-value');
        if (valueEl && q5Value) {
          q5Value.value = valueEl.textContent.replace(/ /g, '');
        }
        setStep('question-5', 'question-6', 'diagnose-circle-5', 'diagnose-circle-6');

        const q2Value = document.getElementById('question-2-value');
        const q3Value = document.getElementById('question-3-value');
        const q4Value = document.getElementById('question-4-value');
        const q5HiddenValue = document.getElementById('question-5-value');

        if (!q2Value || !q3Value || !q4Value || !q5HiddenValue) {
          return;
        }

        let type = '';
        if (q2Value.value === '親指が最も長い') {
          type = 'egypt';
        } else if (q2Value.value === '人差し指や中指が最も長い') {
          type = 'greece';
        } else if (q2Value.value === 'どの指もほぼ同じくらいの長さ') {
          type = 'square';
        }

        const q3Map = {
          '両サイドに圧迫感がある足の指同士が重なってしまう': 1,
          '隙間がある感じがする指先が大きく動いてしまう': 2,
          'ものによって少し窮屈感や緩みを感じるあまり気にならない': 3,
        };
        const question3 = q3Map[q3Value.value] || 0;

        const q4Map = {
          '圧迫感を感じるかかとに刺さっている感じがする': 1,
          '歩くとかかとが抜けることがある擦れてしまう': 2,
          'ものによって少し窮屈感や緩みを感じるあまり気にならない': 3,
        };
        const question4 = q4Map[q4Value.value] || 0;

        const q5Map = {
          '幅がきつく、圧迫感があるデザインによっては足が入らない': 1,
          '幅が緩く、前に滑ってしまう靴と足の間に隙間がある': 2,
          'あまり気にならない': 3,
        };
        const question5 = q5Map[q5HiddenValue.value] || 0;

        localStorage.setItem('diagnose-type', type);
        localStorage.setItem('diagnose-question3', String(question3));
        localStorage.setItem('diagnose-question4', String(question4));
        localStorage.setItem('diagnose-question5', String(question5));
      });
    });

    const cancelBtn = document.getElementById('diagnose-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        startWrapper.classList.remove('hide');
        diagnoseWrapper.classList.remove('show');
        ['question-1', 'question-2', 'question-3', 'question-4', 'question-5', 'question-6'].forEach((id, idx) => {
          const el = document.getElementById(id);
          if (el) {
            el.classList.toggle('current', idx === 0);
            if (idx > 0) {
              el.classList.remove('current');
            }
          }
        });
        const circleIds = [
          'diagnose-circle-1',
          'diagnose-circle-2',
          'diagnose-circle-3',
          'diagnose-circle-4',
          'diagnose-circle-5',
          'diagnose-circle-6',
        ];
        circleIds.forEach((circleId, idx) => {
          const circle = document.getElementById(circleId);
          if (circle) {
            circle.classList.toggle('current', idx === 0);
          }
        });
      });
    }

    const backBtn = document.getElementById('diagnose-back');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        const currentQuestion = diagnoseWrapper.querySelector('.diagnose__question.current');
        const currentCircle = diagnoseWrapper.querySelector('.diagnose__circles .current');

        if (!currentQuestion || !currentCircle) return;

        if (currentQuestion.id === 'question-1') {
          startWrapper.classList.remove('hide');
          diagnoseWrapper.classList.remove('show');
        } else {
          const prevQuestion = currentQuestion.previousElementSibling;
          const prevCircle = currentCircle.previousElementSibling;
          if (prevQuestion) {
            currentQuestion.classList.remove('current');
            prevQuestion.classList.add('current');
          }
          if (prevCircle) {
            currentCircle.classList.remove('current');
            prevCircle.classList.add('current');
          }
        }
      });
    }
  }

  const redirectContainer = document.getElementById('diagnose-redirect');
  if (redirectContainer) {
    if (
      !localStorage.getItem('diagnose-type') ||
      !localStorage.getItem('diagnose-question3') ||
      !localStorage.getItem('diagnose-question4') ||
      !localStorage.getItem('diagnose-question5')
    ) {
      window.location.href = '/pages/diagnose';
      return;
    }

    const q3 = localStorage.getItem('diagnose-question3');
    const q4 = localStorage.getItem('diagnose-question4');
    const q5 = localStorage.getItem('diagnose-question5');
    const type = localStorage.getItem('diagnose-type') || '';

    let resultPath = 'result-6';
    if (q3 === '3' && q4 === '2' && q5 === '3') {
      resultPath = 'result-1';
    } else if (q3 === '3' && q4 === '1' && q5 === '3') {
      resultPath = 'result-2';
    } else if (q3 === '1' && q4 === '3' && q5 === '1') {
      resultPath = 'result-3';
    } else if (q3 === '2' && q4 === '3' && q5 === '2') {
      resultPath = 'result-4';
    } else if (q3 === '1' && q4 === '1' && q5 === '1') {
      resultPath = 'result-5';
    }

    window.location.href = `/pages/${resultPath}?type=${type}`;
  }

  const resultContainer = document.getElementById('diagnose-result');
  if (resultContainer) {
    const params = new URLSearchParams(window.location.search);
    const type = params.get('type');
    if (type) {
      const content = document.getElementById(`result-${type}-content`);
      if (content) {
        content.classList.add('show');
      }
      const link = resultContainer.querySelector('[data-foot-type-link]');
      if (link) {
        link.href = `/pages/foot-type-${type}`;
      }
      const recommendGroup = document.querySelector(`.recommend__group[data-foot-type="${type}"]`);
      if (recommendGroup) {
        recommendGroup.hidden = false;
      }
    }

    const shareBtn = document.getElementById('diagnose-share-btn');
    if (shareBtn) {
      shareBtn.href = `http://twitter.com/share?url=${encodeURIComponent(window.location.href)}`;
    }
  }
})();
